import { useEffect, useState } from "react";
import { QrSheet } from "../public/qr/QrSheet";
import { QrMedia } from "../public/qr/QrMedia";
import { Quantity, Veg } from "../public/qr/QrMenu";
import { money } from "./orderApi";
import { Stars } from "./ItemCards";

export const ItemSheet = ({ item, onClose, onAdd, orderingOpen }) => {
  const [variant, setVariant] = useState(null);
  const [addons, setAddons] = useState([]);
  const [qty, setQty] = useState(1);
  const [note, setNote] = useState("");
  useEffect(() => { setVariant(item?.variants?.[0]?.name || null); setAddons([]); setQty(1); setNote(""); }, [item]);
  if (!item) return null;
  const v = item.variants?.find((x) => x.name === variant);
  const offerUnit = !v && item.offer_price != null ? item.offer_price : null;
  const addonTotal = addons.reduce((s, id) => s + (item.addons?.find((a) => a.id === id)?.price || 0), 0);
  const listUnit = (v ? v.price : item.base_price) + addonTotal;
  // Server applies % offers to the whole line (base + add-ons); flat offers are approximated on the base only.
  const unit = offerUnit == null ? listUnit : item.offer_percent ? Math.round(listUnit * (1 - item.offer_percent / 100) * 100) / 100 : offerUnit + addonTotal;
  const canAdd = orderingOpen && item.is_available && !item.is_combo;
  const disabledText = item.is_combo ? "Combos coming soon" : !item.is_available ? (item.unavailable_reason === "out_of_stock" ? "Out of stock" : "Unavailable") : "Ordering opens soon";
  return (
    <QrSheet title="Make it yours" id="item-sheet" onClose={onClose}>
      <div className="qr-sheet-scroll">
        <QrMedia src={item.image_url} alt={item.name} size="large" className="qr-detail-photo" />
        <div className="qr-detail-heading"><Veg veg={item.veg} /><h2 data-testid="item-sheet-name">{item.name}</h2>
          <strong data-testid="item-sheet-price">{offerUnit != null && <s style={{ color: "#9ca3af", fontWeight: 500, marginRight: 6 }} data-testid="item-sheet-original-price">{money(listUnit)}</s>}{money(unit)}</strong></div>
        <Stars rating={item.rating} id={`sheet-${item.id}`} size="lg" />
        {offerUnit != null && <p className="qr-customizable" style={{ color: "var(--qr-red)" }} data-testid="item-sheet-offer">{item.offer_name || "Website offer"} · applied at checkout</p>}
        {item.description && <p className="qr-detail-description">{item.description}</p>}
        {!item.is_available && <p className="qr-inline-error" data-testid="item-sheet-unavailable">{item.unavailable_reason === "out_of_stock" ? "This dish is currently out of stock." : "This dish is currently unavailable."}</p>}
        {item.variants?.length > 0 && (
          <fieldset className="qr-options" disabled={!canAdd} data-testid="item-sheet-variants"><legend>Choose your portion</legend>
            {item.variants.map((o) => (
              <label key={o.name} className={variant === o.name ? "selected" : ""}>
                <input type="radio" name="order-portion" checked={variant === o.name} onChange={() => setVariant(o.name)} data-testid={`variant-${o.name}`} />
                <span>{o.name}</span><strong>{money(o.price)}</strong>
              </label>
            ))}
          </fieldset>
        )}
        {item.addons?.length > 0 && (
          <fieldset className="qr-options" disabled={!canAdd} data-testid="item-sheet-addons"><legend>A little extra</legend>
            {item.addons.map((a) => (
              <label key={a.id} className={addons.includes(a.id) ? "selected" : ""}>
                <input type="checkbox" checked={addons.includes(a.id)} onChange={(e) => setAddons((s) => (e.target.checked ? [...s, a.id] : s.filter((x) => x !== a.id)))} data-testid={`addon-${a.id}`} />
                <span>{a.name}</span><strong>+{money(a.price)}</strong>
              </label>
            ))}
          </fieldset>
        )}
        {canAdd && (
          <label className="qr-field">Special instructions <span>(optional)</span>
            <textarea rows={2} value={note} maxLength={200} onChange={(e) => setNote(e.target.value)} placeholder="Less spicy, no onion…" data-testid="item-note" />
          </label>
        )}
      </div>
      <div className="qr-sheet-actions">
        {canAdd ? (
          <>
            <Quantity id="item-qty" value={qty} minus={() => setQty((n) => Math.max(1, n - 1))} plus={() => setQty((n) => Math.min(20, n + 1))} />
            <button type="button" className="qr-primary" data-testid="item-add-to-cart"
              onClick={() => { onAdd({ item_id: item.id, name: item.name, image_url: item.image_url, variant_name: variant, addon_ids: addons, qty, note: note.trim() || undefined, unit }); onClose(); }}>
              Add to Cart · {money(unit * qty)}
            </button>
          </>
        ) : <button type="button" className="qr-primary" disabled data-testid="item-sheet-add-disabled">{disabledText}</button>}
      </div>
    </QrSheet>
  );
};
